import { createEventString } from '@seek/seek-impression-tracking/build/createEventString';
import { jobTrackingUrl } from 'src/config';
export const searchImpressionType = 'searchImpression2';
export const searchImpressionExitType = 'searchImpressionExit2';
import { createUnauthenticatedHttpClient } from 'src/modules/seek-api-request';

export default ({
  type = 'log2',
  data: { sessionId, channel = 'web', view = 'unknown', ...data }
}) => {
  const payload = {
    type,
    data: {
      channel,
      view,
      sessionId,
      ...data
    }
  };

  return createUnauthenticatedHttpClient({ omitXSeekSiteHeader: true })
    .send({
      label: 'presto-tracking',
      url: jobTrackingUrl,
      params: {
        events: createEventString(payload),
        sessionId
      }
    })
    .then(({ data }) => data); // eslint-disable-line no-shadow
};
